module.exports = __webpack_public_path__ + "img/2Icon.89629a92.png";